import React from 'react';

const Emoji= () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="35" height="35">
      <defs>
        <style>{`.cls-2{fill:#273941}.cls-4{fill:#f6fafd}`}</style>
      </defs>
      <g id="_04-wink" data-name="04-wink">
        <circle cx="24" cy="24" r="23" style={{ fill: '#ffce52' }} />
        <ellipse className="cls-2" cx="15" cy="18" rx="3" ry="4" />
        <ellipse cx="15" cy="18" rx="2" ry="3" style={{ fill: '#141e21' }} />
        <circle className="cls-4" cx="16" cy="17" r="1" />
        <path className="cls-2" d="M23 38c-5.424 0-10-4.3-10-7h2c0 1.208 3.319 5 8 5 6.617 0 12-4.935 12-11h2c0 7.168-6.28 13-14 13zM36.445 22.832l-6-4a1 1 0 0 1 .108-1.727l6-3 .894 1.79-4.459 2.229 4.567 3.044z" />
        <path d="M24 4c12.15 0 22 8.507 22 19h.975a23 23 0 0 0-45.95 0H2C2 12.507 11.85 4 24 4z" style={{ fill: '#ffe369' }} />
        <path d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z" style={{ fill: '#ffb32b' }} />
        <ellipse className="cls-4" cx="37" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 37 9)" />
        <ellipse className="cls-4" cx="30.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 30.745 4.5)" />
        <ellipse className="cls-4" cx="34" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 34 7)" />
      </g>
    </svg>
  );
};

export default Emoji;
